// Predykat wpięcia bramki NoCompanyGate (D2).
//
// Wydzielony z komponentu z dwóch powodów: żeby dało się go przetestować bez renderu
// i żeby jedyne miejsce, które decyduje o ZABLOKOWANIU aplikacji, było jawne i krótkie.
//
// Model firmowy NIE JEST już opcją (profile skasowane, /profile/current nie istnieje),
// więc zniknęło zwarcie na fladze utils/companyModelFlag: bez firmy nie da się zapisać
// niczego, a listy zawężają się do pustego WorkspaceId. Zamiast pustej aplikacji bez
// wyjaśnienia pokazujemy ekran „załóż kancelarię albo przyjmij zaproszenie".

/**
 * Ścieżki, na których bramka NIE MOŻE się pojawić, bo to jedyne drogi WYJŚCIA ze stanu
 * „konto bez firmy” (albo diagnostyka tego stanu). Zablokowanie ich zamknęłoby użytkownika
 * w pętli: bramka → zaproszenie → bramka.
 */
export const EXEMPT_PATH_PREFIXES = [
  "/activation",
  "/recovery",
  "/invitation",
  "/choose-workspace",
  "/debug",
  "/contactFormVerification",
];

export interface INoCompanyGateInput {
  /** Czy zalogowany należy do firmy (CompanyContext.hasCompany). */
  hasCompany: boolean;
  /** Czy trwa jeszcze pobieranie firmy — w trakcie ładowania NIE blokujemy. */
  isLoading: boolean;
  /**
   * Czy pobranie firmy się NIE UDAŁO. Awaria sieci wygląda z zewnątrz identycznie jak brak
   * firmy (`hasCompany === false`), a to dwa różne stany: przy błędzie bramka ma się NIE
   * pokazać, bo namawiałaby na założenie drugiej kancelarii komuś, kto swoją już ma.
   */
  isError?: boolean;
  /** Bieżąca ścieżka — patrz EXEMPT_PATH_PREFIXES. */
  pathname?: string;
}

export const shouldShowNoCompanyGate = ({
  hasCompany,
  isLoading,
  isError,
  pathname,
}: INoCompanyGateInput): boolean => {
  if (hasCompany) return false;
  // Fail-open: brak odpowiedzi (albo odpowiedź nieudana) to nie jest dowód braku firmy.
  if (isLoading || isError) return false;

  if (
    pathname &&
    EXEMPT_PATH_PREFIXES.some(
      (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
    )
  )
    return false;

  return true;
};
